import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CenterLocations.css';
import BannerUpdate from '../../components/BannerUpdate/BannerUpadate';
import API_URL from '../../api/ExamCalendarApi';
const CenterLocations = () => {
  const [locations, setLocations] = useState([]);

  const [formData, setFormData] = useState({
    locationUrl: '',
    centreName: '',
    mobile: '',
    email: '',
    address: '',
    city: '',
    state: '',
    pincode: ''
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    fetchLocations();
  }, []);

  const fetchLocations = async () => {
    try {
      const response = await axios.get(`${API_URL}/centers/centers-location`);
      setLocations(response.data);
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`${API_URL}/centers/centers-location/${editingId}`, formData);
        setEditingId(null);
      } else {
        await axios.post(`${API_URL}/centers/centers-location`, formData);
      }
      setFormData({
        locationUrl: '',
        centreName: '',
        mobile: '',
        email: '',
        address: '',
        city: '',
        state: '',
        pincode: ''
      });
      fetchLocations();
    } catch (error) {
      console.error('Error saving location:', error);
    }
  };

  const handleEdit = (location) => {
    setFormData(location);
    setEditingId(location._id);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API_URL}/centers/centers-location/${id}`);
      fetchLocations();
    } catch (error) {
      console.error('Error deleting location:', error);
    }
  };

  return (
    <div className="admin-centerlocation-container">
       <BannerUpdate pageName="our-centres" />
      <h2 className="admin-centerlocation-title">Center Locations</h2>
      <form className="admin-centerlocation-form" onSubmit={handleSubmit}>
        <div className="admin-centerlocation-form-row">
          <input
            type="text"
            className="admin-centerlocation-input"
            name="locationUrl"
            placeholder="Location URL"
            value={formData.locationUrl}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            className="admin-centerlocation-input"
            name="centreName"
            placeholder="Center Name"
            value={formData.centreName}
            onChange={handleInputChange}
          />
        </div>
        <div className="form-row">
          <input
            type="text"
            className="admin-centerlocation-input"
            name="mobile"
            placeholder="Mobile"
            value={formData.mobile}
            onChange={handleInputChange}
            pattern="[0-9]{10}"
            title="Mobile number must be 10 digits"
            required
          />
          <input
            type="email"
            className="admin-centerlocation-input"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleInputChange}
            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
            title="Please enter a valid email address"
            required
          />
        </div>
        <div className="form-row">
          <input
            type="text"
            className="admin-centerlocation-input"
            name="address"
            placeholder="Address"
            value={formData.address}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="form-row">
          <input
            type="text"
            className="admin-centerlocation-input"
            name="city"
            placeholder="City"
            value={formData.city}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            className="admin-centerlocation-input"
            name="state"
            placeholder="State"
            value={formData.state}
            onChange={handleInputChange}
            required
          />
          <input
            type="text"
            className="admin-centerlocation-input"
            name="pincode"
            placeholder="Pincode"
            value={formData.pincode}
            onChange={handleInputChange}
            pattern="[0-9]{6}"
            title="Pincode must be 6 digits"
            required
          />
        </div>
        <button type="submit" className="admin-centerlocation-button">
          {editingId ? 'Update' : 'Create'} Location
        </button>
      </form>

      <h3 className="admin-centerlocation-subtitle">Existing Center Locations</h3>
      <div className="admin-centerlocation-table-container">
        <table className="admin-centerlocation-table">
          <thead>
            <tr>
              <th>Center Name</th>
              <th>Location URL</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>Address</th>
              <th>City</th>
              <th>State</th>
              <th>Pincode</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {locations.map((location) => (
              <tr key={location._id}>
                <td>{location.centreName}</td>
                <td className="admin-centerlocation-ellipsis">{location.locationUrl}</td>
                <td>{location.mobile}</td>
                <td>{location.email}</td>
                <td>{location.address}</td>
                <td>{location.city}</td>
                <td>{location.state}</td>
                <td>{location.pincode}</td>
                <td>
                  <button
                    className="admin-centerlocation-button admin-centerlocation-button-warning"
                    onClick={() => handleEdit(location)}
                  >
                    Edit
                  </button>
                  <button
                    className="admin-centerlocation-button admin-centerlocation-button-danger"
                    onClick={() => handleDelete(location._id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default CenterLocations;
